<template>
  <div class="swiper">
    <!-- mobile swiper -->
    <div v-if="isProduct" class="outer-box-carousel mShow">
      <div id="m_swiper" v-swiper:mSwiper="MswiperOption"  class="mShow">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in mImg" :key="item.url">
            <img class="img-m" :src="item" alt="">
          </div>
        </div>
        <div class="swiper-pagination"></div>
      
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="noProduct" v-if="!isProduct">Sorry, we are working hard to develop a product that meets your needs. Please stay tuned to us! </div>
    <!-- pc swiper -->
    <div v-if="isProduct" class="outer-box-carousel pcShow" >
      <div id="pc_swiper"  v-swiper:pcSwiper="PCswiperOption" class="pcShow">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in pcImg" :key="item.url">
            <img class="img-pc" :src="item" alt="">
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    
  </div>
</template>
<script>
// import Swiper from 'swiper/js/swiper';
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)

export default {
  data () {
    return {
      pcImg:[],
      mImg: [],
      isProduct: '',
      PCswiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        slidesPerView : 3,
        centerInsufficientSlides: true,
        // spaceBetween : 61,
        spaceBetween: 131,
        slidesPerGroup : 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      MswiperOption: {
        spaceBetween : 40,
        pagination: {
          el: '.swiper-pagination',
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  },
  mounted(){
    const pcProductMap = {
      'FM-INSI-101': require("../assets/product-pc/Myo.png"),
      'FM-PREVI-101': require("../assets/product-pc/Prenatal.png"),
      'FM-DIM-101': require("../assets/product-pc/DIM.png"),
      'FM-EPOIL-101': require("../assets/product-pc/Evening Primrose Oil.png"),
      'FM-POSVI-101': require("../assets/product-pc/Postnatal.png"),
      'FM-CRANB-101': require("../assets/product-pc/Cranberry Concentrate.png"),
      'FM-ELDER-101': require("../assets/product-pc/Elderberry.png"),
      'FM-MCPEP-101': require("../assets/product-pc/Marine.png"),
      'FM-VCOLB-101': require("../assets/product-pc/VCB.png"),
      'FM-WMV-101': require("../assets/product-pc/Women’s Multivitamin.png"),
      'FM-PROBI-101': require("../assets/product-pc/Women’s Probiotic.png")
    }
    const mProductMap = {
      'FM-INSI-101': require("../assets/product-m/Myo.png"),
      'FM-PREVI-101': require("../assets/product-m/Prenatal.png"),
      'FM-DIM-101': require("../assets/product-m/dim.png"),
      'FM-EPOIL-101': require("../assets/product-m/Evening Primrose Oil.png"),
      'FM-POSVI-101': require("../assets/product-m/Postnatal Multivitamin.png"),
      'FM-CRANB-101': require("../assets/product-m/Cranberry Concentrate.png"),
      'FM-ELDER-101': require("../assets/product-m/Elderberry.png"),
      'FM-MCPEP-101': require("../assets/product-m/Marine.png"),
      'FM-VCOLB-101': require("../assets/product-m/VCB.png"),
      'FM-WMV-101': require("../assets/product-m/Women’s Multivitamin.png"),
      'FM-PROBI-101': require("../assets/product-m/Women’s Probiotic.png")
    }
    this.$store.state.product.forEach(msku => {
      this.pcImg.push(pcProductMap[msku])
      this.mImg.push(mProductMap[msku])
    });
    if ( this.pcImg.length === 0 || this.mImg.length === 0 ) {
      this.isProduct = false
    } else {
      this.isProduct = true
    }


  }
};
</script>
<style lang="less" >
.swiper{
  width: 100%;
  // overflow: hidden;
}
@media only screen and (max-width: 765px) {
  .outer-box-carousel {
    width: 340px;
    height: 478px;
    overflow: hidden;
  }
  .noProduct {
    font-size: 22px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #000000;
    text-align: center;
    padding: 60px 24px;
  }
}
@media only screen and (min-width: 765px) {
  .noProduct {
    font-size: 34px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #000000;
    text-align: center;
    padding: 60px 0;
  }
  .outer-box-carousel {
    width: 1360px;
    height: 505px;
    // height: 600px;
    overflow: hidden;
  }
  .swiper-slide{
    // width:300px;/*设为固定值*/
    width: 390px;
    // width: 100%;
  }
}
#m_swiper{
  width: 309.5px;
  overflow: visible;
  height: 100%;
  .img-m {
    width: 310px;
    overflow: hidden;
    margin: 0 auto;
    height: 415px;
    background: #FFFFFF;
    box-shadow: 0px 21px 39px 0px rgba(177, 144, 123, 0.14);
    border-radius: 12.5px;
    filter: blur(0px);
    // overflow: visible;
  }
  .swiper-pagination {
    // position: relative;
    // top: 25px;
    .swiper-pagination-bullet-active {
      background: #D8D8D8;
    }
    .swiper-pagination-bullet {
      background: #D8D8D8;
    }
    
    // overflow: visible!important;
    
  }
  
  .swiper-button-prev {
    position: absolute;
    left: -11px;
    overflow: visible;
    width: 22px;
    height: 22px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4.5px 1.5px rgba(170, 163, 163, 0.21);
    border-radius: 50%;
    &::after{
      color: #333131;
      font-size: 12px;
    }
  }
  .swiper-button-next {
    width: 22px;
    position: absolute;
    right: -11px;
    height: 22px;
    overflow:visible;
    background: #FFFFFF;
    box-shadow: 0px 0px 4.5px 1.5px rgba(170, 163, 163, 0.21);
    border-radius: 50%;
    &::after{
      color: #333131;
      font-size: 12px;
    }
  }
}
#pc_swiper{
  overflow: visible;
  width: 1292px;
  height: 100%;
  margin: 0 auto;
  .img-pc {
    width: 345px;
    // width: 100%;
    // width: 300px;
    &:hover {
      box-shadow: 0px 27px 49px 0px rgba(177, 144, 123, 0.14);
    }
  }
  .swiper-pagination {
    // position: absolute;
    // top: -10%;
    .swiper-pagination-bullet-active {
      background: #D8D8D8;
    }
    .swiper-pagination-bullet {
      background: #D8D8D8;
      width: 11px;
      height: 11px;
    }
  }
  .swiper-button-prev {
    width: 44px;
    position: absolute;
    left: -22px;
    height: 44px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 3px rgba(170, 163, 163, 0.21);
    border-radius: 50%;
    &::after{
      color: #333131;
      font-size: 23px;
    }
  }
  .swiper-button-next {
    position: absolute;
    right: -22px;
    width: 44px;
    height: 44px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 3px rgba(170, 163, 163, 0.21);
    border-radius: 50%;
    &::after{
      color: #333131;
      font-size: 23px;
    }
  }
}
</style>